/*
|--------------------------------------------------------------------------
| Site Forms: Search Form
|--------------------------------------------------------------------------
*/
__gh__webApp.siteForms.newsletterForm = {

	/**
	 * Initialize search form
	 */
	"init": function(){
		this.bindEvents();
	},


	/**
	 * Bind the events for the search form
	 */
	"bindEvents": function(){
		var thisObject				= __gh__webApp.siteForms.searchForm,
			$newsletterForm 		= $("form[Name=newsletter1]"),
			trackNewsletterSignUp 	= __gh__webApp.utilities.tracker.trackNewsletterSignUp;
			
		
		$newsletterForm.submit(function(event){
			var email = $newsletterForm.find("#Email").val();
			trackNewsletterSignUp({
				"email": email
			});
		});

	}

};